import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column mt-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-100 py-3 mb-2" }, null, -1 /* HOISTED */)
const _hoisted_3 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("There was an error while getting your agencies."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Please try again.")
], -1 /* HOISTED */)
const _hoisted_5 = {
  key: 2,
  id: "App__Agencies_Vue"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("header", {
  class: "text-app-primary group-title-vue no-pointer",
  id: "hospiceMarketing"
}, "AxxessHospice", -1 /* HOISTED */)
const _hoisted_7 = ["id", "onClick"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" LOADING "),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
            return _createElementVNode("div", {
              class: "d-flex flex-column w-100 mt-3",
              key: `loading-${i}`
            }, [
              _hoisted_2,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                return _createElementVNode("span", {
                  class: "shimmer-loading w-80 py-3 mb-2",
                  key: `shimmer-${i}`
                })
              }), 64 /* STABLE_FRAGMENT */))
            ])
          }), 64 /* STABLE_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" ERROR "),
    (_ctx.hasError && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            class: "btn btn-primary btn-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reloadAgencies()))
          }, "Try Again")
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" AGENCY LIST "),
    (!_ctx.hasError && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
          _createCommentVNode(" HOSPICE MARKETING LINK "),
          (_ctx.isBeforeHosMarketingLastDate && _ctx.groupedAgencies.size)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_6,
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn btn-hospice-primary d-block w-100 fw-bold",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openHospiceMarketingLink()))
                }, " Learn More ")
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" AGENCY BY PRODUCT "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedAgencies, ([applicationName, list]) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: applicationName }, [
              _createElementVNode("header", {
                class: "group-title-vue",
                id: applicationName,
                onClick: ($event: any) => (_ctx.showAgency(list))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.getProductColorClass(applicationName))
                }, _toDisplayString(applicationName), 3 /* TEXT, CLASS */),
                _createElementVNode("i", {
                  class: _normalizeClass(`me-1 ms-auto arrow-color fas fa-caret-${list.show ? 'down' : 'up'}`)
                }, null, 2 /* CLASS */)
              ], 8 /* PROPS */, _hoisted_7),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.data, (agency, index) => {
                return _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: `agency-btn-${index}`,
                  class: _normalizeClass(`btn btn-vue btn-block-vue ${applicationName} font-size-base ${_ctx.getProductColorClass(
                    applicationName
                )}`),
                  onClick: ($event: any) => (_ctx.enterAgency(agency))
                }, _toDisplayString(agency.Name), 11 /* TEXT, CLASS, PROPS */, _hoisted_8)), [
                  [_vShow, agency && list.show]
                ])
              }), 128 /* KEYED_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}